import { PRODUCT_META } from '@gb-ticket/shared-types';

export const INTRANET_ROOT = PRODUCT_META.intranet.pathPrefix;
/** Detail pages live under this prefix. The bare path redirects to the feed. */
export const INTRANET_NEWS_PATH = `${INTRANET_ROOT}/nachrichten`;
export const INTRANET_LIBRARY_PATH = `${INTRANET_ROOT}/wissensdatenbank`;
/** Editorial list of Wissensdatenbank categories, including empty ones. */
export const INTRANET_KNOWLEDGE_CATEGORIES_PATH = `${INTRANET_LIBRARY_PATH}/kategorien`;
export const INTRANET_KNOWLEDGE_QUICK_ACCESS_PATH = `${INTRANET_LIBRARY_PATH}/schnellzugriff`;
/** Legacy search page. The route redirects to the feed and keeps `q`. */
export const INTRANET_SEARCH_PATH = `${INTRANET_ROOT}/suche`;
export const INTRANET_COLLEAGUES_PATH = `${INTRANET_ROOT}/kollegen`;
export const INTRANET_CHAT_PATH = `${INTRANET_ROOT}/chat`;
export const INTRANET_AI_PATH = `${INTRANET_ROOT}/ki`;
export const INTRANET_CONTACTS_PATH = `${INTRANET_ROOT}/ansprechpartner`;
export const INTRANET_EDITORIAL_PATH = `${INTRANET_ROOT}/redaktion`;
/** Legacy composer URL. The route redirects to `INTRANET_CHANNEL_COMPOSE_PATH` and keeps the query. */
export const INTRANET_EDITORIAL_NEW_PATH = `${INTRANET_EDITORIAL_PATH}/neu`;
/** Single composer for new posts. `category` preselects a channel for authors. */
export const INTRANET_CHANNEL_COMPOSE_PATH = `${INTRANET_ROOT}/beitrag/neu`;
export const INTRANET_CATEGORIES_PATH = `${INTRANET_EDITORIAL_PATH}/kategorien`;
export const INTRANET_EDITORIAL_CONTACTS_PATH = `${INTRANET_EDITORIAL_PATH}/ansprechpartner`;
/** Legacy link editor. The route redirects to the Schnellzugriff page. */
export const INTRANET_EDITORIAL_LINKS_PATH = `${INTRANET_EDITORIAL_PATH}/links`;
export const INTRANET_EDITORIAL_SHORTCUTS_PATH = `${INTRANET_EDITORIAL_PATH}/schnellzugriff`;
export const INTRANET_EDITORIAL_APPEARANCE_PATH = `${INTRANET_EDITORIAL_PATH}/erscheinungsbild`;
export const INTRANET_EDITORIAL_SETTINGS_PATH = `${INTRANET_EDITORIAL_PATH}/einstellungen`;

/** Schnellzugriff module tile and form shell. */
export function intranetModulePath(instanceId: string): string {
  return `${INTRANET_ROOT}/modul/${encodeURIComponent(instanceId)}`;
}

/** `/intranet/suche?q=` lands on the feed search field. */
export function intranetSearchRedirectTarget(q: string | null | undefined): string {
  const term = q?.trim() ?? '';
  if (term.length === 0) {
    return INTRANET_ROOT;
  }
  return `${INTRANET_ROOT}?q=${encodeURIComponent(term)}`;
}

export function intranetEditPath(slug: string): string {
  return `${INTRANET_ROOT}/beitrag/${encodeURIComponent(slug)}/bearbeiten`;
}

export function intranetChannelComposePath(categoryId?: string): string {
  return categoryId
    ? `${INTRANET_CHANNEL_COMPOSE_PATH}?category=${encodeURIComponent(categoryId)}`
    : INTRANET_CHANNEL_COMPOSE_PATH;
}

/** Same address as `intranetEditPath`. */
export function intranetChannelEditPath(slug: string): string {
  return intranetEditPath(slug);
}

export function intranetAcknowledgementsReportPath(slug: string): string {
  return `${INTRANET_EDITORIAL_PATH}/${encodeURIComponent(slug)}/bestaetigungen`;
}

/** Settings for one rubric, on the filtered start page. */
export function intranetCategorySettingsPath(slug: string): string {
  return `${INTRANET_ROOT}?category=${encodeURIComponent(slug)}&einstellungen=1`;
}

export function intranetChatPath(conversationId?: string): string {
  return conversationId
    ? `${INTRANET_CHAT_PATH}/${encodeURIComponent(conversationId)}`
    : INTRANET_CHAT_PATH;
}
